import React from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, Button, Box, Avatar } from '@mui/material';
import { Pageheader } from './global-components/page-header';
import { ReactComponent as MainLogo4Svg } from '../assets/img/Main Logo 4.svg';
import { useNavigate } from 'react-router-dom';
import { blogData } from '../constants/blogData';

const blogHeaderBg = require('../assets/img/newimgaes/Jays Home Garden.jpg');
const blogAuthor = {
  name: 'Royale Spaces',
};

const Blog = () => {
  const navigate = useNavigate();
  const globalBlogs = blogData.filter(post => post.newsType === 'global');

  const handleReadMore = (slug) => {
    navigate(`/blog/${slug}`);
  };

  return (
    <>
      <Pageheader headertitle="Blog" bgImage={blogHeaderBg} />
      <div className="container" style={{ marginTop: 40, marginBottom: 40 }}>
        <Grid container spacing={4} justifyContent="center">
          {globalBlogs.map((blog) => (
            <Grid item xs={12} sm={6} md={4} key={blog.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  boxShadow: '0 8px 32px rgba(16,55,74,0.10)',
                  transition: 'transform 0.25s cubic-bezier(.4,0,.2,1), box-shadow 0.25s',
                  border: '1.5px solid #d8b035',
                  position: 'relative',
                  overflow: 'hidden',
                  '&:hover': {
                    transform: 'translateY(-8px) scale(1.03)',
                    boxShadow: '0 16px 48px rgba(216,176,53,0.18)',
                    borderColor: '#b89c2c',
                  },
                }}
              >
                {/* Gold accent bar at the top */}
                <Box sx={{ height: 6, width: '100%', background: 'linear-gradient(90deg, #d8b035 60%, #fffbe6 100%)', position: 'absolute', top: 0, left: 0, zIndex: 2 }} />
                <CardMedia
                  component="img"
                  height="200"
                  image={blog.image}
                  alt={blog.title}
                  sx={{ objectFit: 'cover', borderTopLeftRadius: 8, borderTopRightRadius: 8, mt: 1 }}
                />
                <CardContent sx={{ flexGrow: 1, p: 3, pt: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Avatar sx={{ width: 32, height: 32, mr: 1, bgcolor: '#fff' }}>
                      <MainLogo4Svg style={{ width: 28, height: 28 }} />
                    </Avatar>
                    <Typography variant="subtitle2" color="#10374A" fontWeight={700} sx={{ mr: 1, mt: 1 }}>{blogAuthor.name}</Typography>
                  </Box>
                  <Typography variant="h6" fontWeight={800} gutterBottom color="#10374A" sx={{ minHeight: 64 }}>
                    {blog.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 3, minHeight: 80 }}>
                    {blog.excerpt}
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => handleReadMore(blog.slug)}
                    sx={{
                      background: '#d8b035',
                      color: '#fff',
                      fontWeight: 700,
                      borderRadius: 3,
                      px: 3,
                      py: 1.2,
                      boxShadow: '0 2px 8px rgba(216,176,53,0.10)',
                      letterSpacing: 0.5,
                      textTransform: 'none',
                      fontSize: '1rem',
                      '&:hover': {
                        background: '#fff',
                        color: '#d8b035',
                        border: '1.5px solid #d8b035',
                        boxShadow: '0 4px 16px rgba(216,176,53,0.18)',
                      },
                    }}
                  >
                    Read More
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default Blog;